import * as microstructureModule from './tests/microstructure_photos'

export const getTest = (test: string) => {
  if (test === 'microstructure_photos' || test === 'microstructure_photos_longitudinal') {
    return microstructureModule
  }
  return microstructureModule
}
